module.exports = __webpack_public_path__ + "img/1518968940.2d4855a7.jpg";